import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';

export interface CreateGroupRequest {
  name: string;
}

export interface UpdateGroupRequest {
  name: string;
}

export interface DetailsFieldGroup {
  id: number;
  name: string;
  createdAt: string;
}

export const DETAILS_FIELD_GROUPS_UPDATED = 'DETAILS_FIELD_GROUPS_UPDATED';

export function useDetailsFieldGroupsAdminService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  const createGroup = async (request: CreateGroupRequest): Promise<DetailsFieldGroup> => {
    const result = await nekstApi.post('/manager/detailsfieldgroups', request) as DetailsFieldGroup;
    eventsPublisher.publish(DETAILS_FIELD_GROUPS_UPDATED, {});
    return result;
  };

  const updateGroup = async (id: number, request: UpdateGroupRequest): Promise<DetailsFieldGroup> => {
    const result = await nekstApi.put(`/manager/detailsfieldgroups/${id}`, request) as DetailsFieldGroup;
    eventsPublisher.publish(DETAILS_FIELD_GROUPS_UPDATED, {});
    return result;
  };

  const getGroups = async (): Promise<DetailsFieldGroup[]> => {
    return await nekstApi.get('/manager/detailsfieldgroups') as DetailsFieldGroup[];
  };

  const deleteGroup = async (id: number): Promise<void> => {
    await nekstApi.delete(`/manager/detailsfieldgroups/${id}`);
    eventsPublisher.publish(DETAILS_FIELD_GROUPS_UPDATED, {});
  };

  return {
    createGroup,
    updateGroup,
    getGroups,
    deleteGroup,
  };
}
